/** Bỏ dấu tiếng Việt và chuẩn hoá khoảng trắng. */
export function boDauTiengViet(s) {
  if (s == null || s === "") return "";
  return String(s)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .replace(/\s+/g, " ")
    .trim();
}

/**
 * Khớp tên ngân hàng đã lưu (thường là shortName từ ChonNganHang) với
 * phần tử trong danh sách VietQR (name/code/tenDayDu), không phân biệt hoa thường.
 */
export function timNganHangTheoTen(tenNganHang, danhSach) {
  if (!tenNganHang || !Array.isArray(danhSach) || danhSach.length === 0) return null;
  const key = String(tenNganHang).trim().toLowerCase();
  if (!key) return null;
  return (
    danhSach.find((b) => {
      const candidates = [b.name, b.code, b.tenDayDu, b.shortName].filter(Boolean);
      return candidates.some((v) => String(v).trim().toLowerCase() === key);
    }) ?? null
  );
}

/**
 * URL ảnh QR VietQR (compact2) — dùng <img src={url} />, không đưa URL vào QrCodeImage.
 */
export function taoUrlAnhVietQr({ bin, soTk, soTien, noiDung, tenChuTk }) {
  const soTkChiSo = String(soTk ?? "").replace(/\D/g, "");
  if (!bin || !soTkChiSo) return "";
  const amount = Math.round(Number(soTien) || 0);
  const addInfo = encodeURIComponent(noiDung ?? "");
  const accountName = encodeURIComponent(tenChuTk ?? "");
  return `https://img.vietqr.io/image/${bin}-${soTkChiSo}-compact2.png?amount=${amount}&addInfo=${addInfo}&accountName=${accountName}`;
}

/** Nội dung CK không dấu, tối đa 25 ký tự (giới hạn VietQR/NAPAS addInfo). */
export function taoNoiDungChuyenKhoanKhongDau({ tenChuVuon, thoiGian }) {
  const d = thoiGian ? new Date(thoiGian) : new Date();
  const ngay = Number.isNaN(d.getTime())
    ? ""
    : `${String(d.getDate()).padStart(2, "0")}${String(d.getMonth() + 1).padStart(2, "0")}${String(
        d.getFullYear()
      ).slice(-2)}`;
  const prefix = ngay ? `TM ${ngay} ` : "TM ";
  const ten = boDauTiengViet(tenChuVuon ?? "")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .replace(/\s+/g, " ")
    .trim();
  const conLai = Math.max(0, 25 - prefix.length);
  return `${prefix}${ten.slice(0, conLai)}`.trim().slice(0, 25);
}
